import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=226da46c&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('226da46c')) {
      api.createRecord('226da46c', component.options)
    } else {
      api.reload('226da46c', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=226da46c&", function () {
      api.rerender('226da46c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2u5XJyY7FrHdU/JS/comp/FavElement.vue"
export default component.exports